import React from 'react'
import classes from 'classnames'
import { Logo } from '@wallyhealth/web-core'
import styles from './index.module.css'

const PageTemplate = ({ children, bodyClassName }) => (
  <div className={styles.container}>
    <header className={styles.header}>
      <div className={styles.logo_bar}>
        <Logo className={styles.logo} color="black" />
      </div>
    </header>
    <div className={classes(styles.body, bodyClassName)}>
      {children}
    </div>
  </div>
)

export default PageTemplate
